import {External, M} from "../external";
import VideoProperties from "./Admin/VideoProperties.svelte";
import { showActivateAddonUI } from '../Billing/Addons/addons';

// export const VIDEO_SERVICE_URL = 'http://localhost:8080/video';
export const VIDEO_SERVICE_URL = `https://${External.serviceApiDomain}/video`;

export const embeddedVideoURL = (elementId, options) => {
  let embeddedOptions = options;
  if (!embeddedOptions) {
    embeddedOptions = {
      autoplay: true,
      loop: true,
      videoMuted: true,
      removeControls: true,
      asBackground: true,
    }
  }
  return VIDEO_SERVICE_URL + '/embedded/' + getVideoElementId(elementId) + '?' + new URLSearchParams(embeddedOptions);
}

export let getVideoMetadataById = (videoId) => {
  return getVideoService('/file/' + videoId + '/meta');
}

export let updateVideoMetadata = (id, video, callback) => {
  let videoMeta = {
    title: video.title,
    thumbnail: video.thumbnail,
    thumbnailFileBase: video.thumbnailFileBase,
    thumbnailFileName: video.thumbnailFileName,
    captions: video.captions,
    categories: video.categories,
    contentOverlay: video.contentOverlay,
    description: video.description,
    backgroundColor: video.backgroundColor,
    timestamps: video.timestamps,
  };
  return patchVideoService('/file/' + id + '/meta', videoMeta)
      .then((resp) => {
        callback(resp);
      }).catch(err => {
        defaultErrorHandling();
      });
}

export const getVideoService = (endpoint, params) => {
  let queryParams = new URLSearchParams(params);
  return fetch(VIDEO_SERVICE_URL + endpoint + '?' + queryParams, {
    headers: {
      'X-Website-Hash': External.WebPlatform.hash,
      'X-Admin-Hash': External.Website.hash
    }
  })
    .then((response) => response.json())
    .then((responseJson) => {
      if (responseJson.code === 200) {
        return responseJson.payload;
      } else {
        return Promise.reject(responseJson);
      }
    });
}

export const putVideoService = (endpoint, body, params) => {
  let queryParams = params ? new URLSearchParams(params) : '';
  let bodyJson = body ? JSON.stringify(body) : '';
  return fetch(VIDEO_SERVICE_URL + endpoint + "?" + queryParams, {
    method: 'PUT',
    headers: {
      'X-Website-Hash': External.WebPlatform.hash,
      'X-Admin-Hash': External.Website.hash,
      'Content-Type': 'application/json'
    },
    body: bodyJson
  })
    .then((response) => response.json())
    .then((responseJson) => {
      if (responseJson.code === 200) {
        return responseJson.payload;
      } else {
        return Promise.reject(responseJson)
      }
    });
}

export const patchVideoService = (endpoint, body, params) => {
  let queryParams = params ? new URLSearchParams(params) : '';
  let bodyJson = body ? JSON.stringify(body) : '';
  return fetch(VIDEO_SERVICE_URL + endpoint + "?" + queryParams, {
    method: 'PATCH',
    headers: {
      'X-Website-Hash': External.WebPlatform.hash,
      'X-Admin-Hash': External.Website.hash,
      'Content-Type': 'application/json'
    },
    body: bodyJson
  })
    .then((response) => response.json())
    .then((responseJson) => {
      if (responseJson.code === 200) {
        return responseJson.payload;
      } else {
        return Promise.reject(responseJson)
      }
    });
}

export const postVideoService = (endpoint, body, params) => {
  let queryParams = params ? new URLSearchParams(params) : '';
  return fetch(VIDEO_SERVICE_URL + endpoint + "?" + queryParams, {
    method: 'POST',
    headers: {
      'X-Website-Hash': External.WebPlatform.hash,
      'X-Admin-Hash': External.Website.hash,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(body)
  })
    .then((response) => response.json())
    .then((responseJson) => {
      if (responseJson.code === 200) {
        return responseJson.payload;
      } else {
        return Promise.reject(responseJson)
      }
    });
}

export const deleteVideoService = (endpoint, params) => {
  let queryParams = params ? new URLSearchParams(params) : '';
  return fetch(VIDEO_SERVICE_URL + endpoint + '?' + queryParams, {
    method: 'DELETE',
    headers: {
      'X-Website-Hash': External.WebPlatform.hash,
      'X-Admin-Hash': External.Website.hash
    }
  })
    .then((response) => response.json())
    .then((responseJson) => {
      if (responseJson.code === 200) {
        return responseJson.payload;
      } else {
        return Promise.reject(responseJson)
      }
    });
}

export const defaultErrorHandling = (err) => {
  if (err && err.code) {
    External.Tools.showError(err.comment);
  } else {
    External.Tools.showError(M.ERROR);
  }
}

export let showVideoMeta = (videoName, videoTitle, folderName, shouldFetchData) => {
  External.Tools.showWindow({
    title: '',
    noTitle: true,
    width: 650,
    forceAtRight: window.showBuilderPopupsOnFullHeight,
    isModal: true,
    withDarkBackground: true,
    buttons: [
      External.Button(M.OK, External.Button.CLASS_MIDDLE_BLUE, (popup) => {
        popup.close();
      }),
      External.Button(M.CANCEL, Button.CLASS_MIDDLE_GREY, (popup) => {
        popup.close();
      })
    ],
    action: {
      onShow: (popup, context) => {
        popup.bindComponent(
          new VideoProperties({
            target: popup.getContentArea(),
            props: {
              videoName: videoName,
              videoTitle: videoTitle,
              folder: folderName,
              shouldFetch: shouldFetchData
            }
          })
        );
      }
    }
  })
}

export let uploadVideo = async (folder, callback, onFail = () => {}) => {
  if (!External.Website.videoHostingHasMoreVideos) {
    await showActivateAddonUI('VIDEO', null, true, "Video Limits Reached!");
    return;
  }
  let selectFileElm = document.createElement('INPUT');
  selectFileElm.setAttribute('type', 'file');
  selectFileElm.setAttribute('accept', 'video/*');

  selectFileElm.hidden = true;
  selectFileElm.onchange = (event) => {
    let file = event.target.files[0];

    if (!file.type.match('video.*')) {
      External.Tools.showError(M.ERROR);
      return;
    }

    let video = document.createElement('video');
    video.preload = 'metadata';

    let disposeVideo = () => {
      video.src = '';
      try {
        video.load()
      } catch (e) {
      }
      video = null;
    }

    video.onloadedmetadata = async () => {
      window.URL.revokeObjectURL(video.src);
      const durationInSeconds = video.duration;

      if (durationInSeconds > (External.Website.videoHostingVideoLengthLimit * 60)) {
        await showActivateAddonUI('VIDEO', null, true, "Video Limits Reached!");
        disposeVideo();
        return;
      }
      disposeVideo();
      startUploadingVideo(selectFileElm, folder, file, callback, onFail);
    };
    video.src = URL.createObjectURL(file);
  };
  selectFileElm.click();
};

const waitForVideo = (folderId, fileName)=> {
  const findNewVideo = async () => {
    const result = await getVideoService(`/folder/${folderId}`, { query: fileName });
    return result && result.length > 0 ? result[0] : null;
  };

  const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));
  return new Promise(async (resolve, reject) => {
    // 5 minutes of polling at maximum
    for (let attempt = 1; attempt <= 300; attempt++) {
      try {
        const video = await findNewVideo();
        if (video) {
          resolve(video);
          return;
        }

        if (attempt < 300) {
          await delay(1000);
        }
      } catch (error) {
        reject(error);
        return;
      }
    }

    reject(new Error('Video not found'));
  });
}

const startUploadingVideo = (selectFileElm, folder, file, callback, onFail) => {
  const FILE_SIZE_THRESHOLD = 64 * 1024 * 1024; // 64MB

  // Use multipart upload for files larger than 64MB
  if (file.size > FILE_SIZE_THRESHOLD) {
    uploadVideoMultipart(selectFileElm, folder, file, callback, onFail);
  } else {
    uploadVideoSingle(selectFileElm, folder, file, callback, onFail);
  }
};

const uploadVideoSingle = (selectFileElm, folder, file, callback, onFail) => {
  let loadingPopup = null;
  External.Tools.showWindow({
    modal: true,
    width: 425,
    title: M.LOADING,
    noNav: true,
    noTitle: true,
    markup:
      `<div class="padded-crm-wrapper-outer">
        <div class="video-processing flex align-center justify-center mb-0">
          <div class="checkout-spinner-wrapper t-center">
            <div class="checkout-spinner"></div>
            <h4>${M.VIDEO_UPLOADING}</h4>
            <span>${M.VIDEO_UPLOADING_DESC}</span>
          </div>
        </div>
      </div>`,
    action: {
      onShow: (popup, ui) => {
        loadingPopup = popup;
      }
    },
    buttons: []
  });
  let filename = External.WebPlatform.removeDiacritics(file.name, true).replace(/[^\da-zA-Z.]/g, '-');
  let uniqueFilename;
  getVideoService('/upload/presignedurl', {
    folder: folder.id,
    filename: filename
  })
    .then((resp) => {
      let presignedUrl = resp.presignedUrl;
      uniqueFilename = resp.newFileName;
      return fetch(presignedUrl, {
        method: 'PUT',
        headers: {
          'Content-Type': file.type
        },
        body: file
      });
    })
    .then((r) => {
      if (r.ok) {
        return waitForVideo(folder.id, uniqueFilename);
      } else {
        throw new Error('Error uploading file');
      }
    })
    .then((newVideoObject) => {
      if (newVideoObject) {
        selectFileElm.remove();
        if (loadingPopup) {
          loadingPopup.close();
          loadingPopup = null;
        }
        callback(newVideoObject);
      }
    })
    .catch((err) => {
      selectFileElm.remove();
      if (loadingPopup) {
        loadingPopup.close();
        loadingPopup = null;
      }
      onFail({});
      defaultErrorHandling({ code: 500, comment: 'Error uploading file' });
    });
};

const uploadVideoMultipart = (selectFileElm, folder, file, callback, onFail) => {
  const PART_SIZE = 64 * 1024 * 1024; // 64MB
  const MAX_CONCURRENT = 6;
  let loadingPopup = null;
  let uploadId = null;
  let newFileName = null;
  let isCancelled = false;
  let progressElement = null;

  const updateProgress = (percentage) => {
    if (progressElement) {
      if (percentage === 100) {
        percentage = 99; // oldest trick in the book, because completing multipart will take some time too
      }
      progressElement.textContent = `${Math.round(percentage)}%`;
    }
  };

  const abortUpload = async () => {
    if (uploadId && newFileName && !isCancelled) {
      isCancelled = true;
      try {
        await postVideoService('/upload/multipart/abort', null, {
          uploadId: uploadId,
          filename: newFileName
        });
      } catch (err) {
        console.error('Failed to abort upload:', err);
      }
    }
  };

  External.Tools.showWindow({
    modal: true,
    width: 425,
    title: M.LOADING,
    noNav: true,
    noTitle: true,
    markup: `<div class="padded-crm-wrapper-outer">
        <div class="video-processing flex align-center justify-center mb-0">
          <div class="checkout-spinner-wrapper t-center">
            <div class="checkout-spinner"></div>
            <h4>${M.VIDEO_UPLOADING}</h4>
            <span>${M.VIDEO_UPLOADING_DESC}</span>
            <div class="upload-progress-wrapper">
              <span id="upload-progress" class="upload-progress">0%</span>
            </div>
          </div>
        </div>
      </div>`,
    action: {
      onShow: (popup, ui) => {
        loadingPopup = popup;
        progressElement = document.getElementById('upload-progress');
      }
    },
    buttons: [
      External.Button(M.CANCEL, External.Button.CLASS_MIDDLE_GREY, async (popup) => {
        await abortUpload();
        selectFileElm.remove();
        popup.close();
        loadingPopup = null;
        onFail({});
      })
    ]
  });

  let filename = External.WebPlatform.removeDiacritics(file.name, true).replace(/[^\da-zA-Z.]/g, '-');

  // Initiate multipart upload
  postVideoService('/upload/multipart/initiate', null, {
    folder: folder.id,
    filename: filename
  })
    .then((data) => {
      uploadId = data.uploadId;
      newFileName = data.newFileName;

      if (!uploadId || !newFileName) {
        throw new Error('Invalid initiate response');
      }

      const totalParts = Math.ceil(file.size / PART_SIZE);
      let uploadedBytes = 0;

      // Upload a single part
      const uploadPart = async (partNumber) => {
        if (isCancelled) {
          throw new Error('Upload cancelled');
        }

        const start = (partNumber - 1) * PART_SIZE;
        const end = Math.min(start + PART_SIZE, file.size);
        const partBlob = file.slice(start, end);

        // Get presigned URL for this part
        const partUrlResponse = await getVideoService('/upload/multipart/presignedurl', {
          uploadId: uploadId,
          filename: newFileName,
          partNumber: partNumber
        });

        if (!partUrlResponse.presignedUrl) {
          throw new Error(`Failed to get presigned URL for part ${partNumber}`);
        }

        // Upload part to S3
        const uploadResponse = await fetch(partUrlResponse.presignedUrl, {
          method: 'PUT',
          headers: {
            'Content-Type': file.type
          },
          body: partBlob
        });

        if (!uploadResponse.ok) {
          throw new Error(`Failed to upload part ${partNumber}`);
        }

        const etag = uploadResponse.headers.get('ETag');
        if (!etag) {
          throw new Error(`No ETag in response for part ${partNumber}`);
        }

        const cleanEtag = etag.replace(/"/g, '');

        // Update progress
        uploadedBytes += end - start;
        const progress = (uploadedBytes / file.size) * 100;
        updateProgress(progress);

        return {
          partNumber: partNumber,
          etag: cleanEtag
        };
      };

      // Upload parts concurrently with max concurrency limit. As soon as one part finishes, start the next one
      const uploadParts = async () => {
        const parts = new Array(totalParts);
        let nextPartIndex = 0;
        let activeUploads = 0;

        return new Promise((resolve, reject) => {
          const startNextUpload = () => {
            // Start new uploads until we reach max concurrency or run out of parts
            while (activeUploads < MAX_CONCURRENT && nextPartIndex < totalParts) {
              if (isCancelled) {
                reject(new Error('Upload cancelled'));
                return;
              }

              const partNumber = nextPartIndex + 1;
              activeUploads++;
              nextPartIndex++;

              uploadPart(partNumber)
                .then((result) => {
                  parts[partNumber - 1] = result;
                  activeUploads--;

                  // If all parts are done, resolve
                  if (nextPartIndex === totalParts && activeUploads === 0) {
                    resolve(parts.filter((p) => p !== undefined));
                  } else {
                    // Start the next upload
                    startNextUpload();
                  }
                })
                .catch((error) => {
                  activeUploads--;
                  reject(error);
                });
            }
          };

          // Start initial batch of uploads
          startNextUpload();
        });
      };

      return uploadParts();
    })
    .then((parts) => {
      if (isCancelled) {
        throw new Error('Upload cancelled');
      }

      // Complete multipart upload
      return postVideoService(
        '/upload/multipart/complete',
        {
          uploadId: uploadId,
          parts: parts
        },
        {
          uploadId: uploadId,
          filename: newFileName
        }
      );
    })
    .then(() => {
      if (isCancelled) {
        throw new Error('Upload cancelled');
      }

      return waitForVideo(folder.id, newFileName);
    })
    .then((newVideoObject) => {
      if (newVideoObject && !isCancelled) {
        selectFileElm.remove();
        if (loadingPopup) {
          loadingPopup.close();
          loadingPopup = null;
        }
        callback(newVideoObject);
      }
    })
    .catch(async (err) => {
      // Attempt to abort on error
      if (uploadId && newFileName && !isCancelled) {
        try {
          await abortUpload();
        } catch (abortErr) {
          console.error('Failed to abort upload on error:', abortErr);
        }
      }

      selectFileElm.remove();
      if (loadingPopup) {
        loadingPopup.close();
        loadingPopup = null;
      }

      if (!isCancelled) {
        onFail({});
        defaultErrorHandling({ code: 500, comment: err.message || 'Error uploading file' });
      }
    });
};

export let totalViewCountView = (viewCount) => {
  if (viewCount > 1000) {
    return (viewCount / 1000).toFixed(2) + 'k';
  }
  return viewCount;
}

export let formatSecondsTimeStamp = (timeInSeconds) => {
  timeInSeconds = parseInt(timeInSeconds);
  if (timeInSeconds % 1 !== 0) {
    timeInSeconds = Math.floor(timeInSeconds);
  }
  if (timeInSeconds > 3600) {
    let h = Math.floor(timeInSeconds / 3600);
    let m = Math.floor((timeInSeconds % 3600) / 60);
    m = m < 10 ? '0' + m : m;
    let s = timeInSeconds % 60;
    s = s < 10 ? '0' + s : s;
    return h + ':' + m + ':' + s;
  } else if (timeInSeconds > 60) {
    let m = Math.floor(timeInSeconds / 60);
    let s = timeInSeconds % 60;
    s = s < 10 ? '0' + s : s;
    return m + ':' + s;
  } else {
    return '0:' + (timeInSeconds < 10 ? '0' + timeInSeconds : timeInSeconds + '');
  }
}

//will remove suffix if added on video's element ID
export let getVideoElementId = (videoId) => {
  if ((videoId.match(/-/g)||[]).length === 4) {
    return videoId;
  }
  let lastDash = videoId.lastIndexOf('-');
  return videoId.slice(0, lastDash);
}

export const extractResolutionsFromM3U8 = (m3u8Url) => {
  return fetch(m3u8Url)
    .then(response => response.text())
    .then(m3u8Content => {
      const lines = m3u8Content.split('\n');
      const resolutions = [];

      lines.forEach(line => {
        if (line.includes('#EXT-X-STREAM-INF')) {
          const resolutionMatch = line.match(/RESOLUTION=\d+x\d+/);
          if (resolutionMatch) {
            const resolution = resolutionMatch[0].split('=')[1];
            resolutions.push(resolution);
          }
        }
      });
      return resolutions;
    })
}

export const getAspectRatio = (width, height) => {
  if (width && width > 0 && height && height > 0) {
    const gcd = findGCD(width, height);
    return (width/gcd) + ":" + (height/gcd);
  } else {
    return '16:9';
  }
}

const findGCD = (a, b) => {
  if (b > a) {
    [a, b] = [b, a];
  }
  return (b === 0) ? a : findGCD(b, a % b);
}

export const loadPlayerScripts = (callback) => {
  External.WebPlatform.requestScripts([{
    script: External.resources + '/scripts/hls.js?v=' + External.resourcesVersion,
    check: () => !!window.Hls
  }, {
    script: External.resources + '/scripts/plyr.polyfilled.js?v=' + External.resourcesVersion,
    style: External.resources + '/styles/plyr.polyfilled.css?v=' + External.resourcesVersion,
    check: () => !!window.Plyr
  }], callback);
}
